module.exports = __webpack_public_path__ + "static/media/plusicon.f0eb7582.png";